<template>
  <div>
    <div>
      <!--      <MyQRCodeScan style="" v-model="qrCode"></MyQRCodeScan>-->
      <h1>掃描QRCode</h1>

      <div v-if="qrCode">
        <h3>報到者資料  </h3>
        <h4 v-if="!CanCheckIn" style="color:red">未報名此場次</h4>
        <table class="table table-hover">
          <thead class="thead-light">
          <tr>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td >{{formData.Id}}</td>
          </tr>
          <tr>
            <td >{{formData.Name}}</td>
          </tr>
          <tr>
            <td >{{formData.EName}}</td>
          </tr>
          <tr>
            <td >{{formData.Group}}</td>
          </tr>

          <tr>
            <td >QRCode:{{qrCode}}</td>
          </tr>

          </tbody>
        </table>

        <h3>回覆資訊</h3>

        <div v-if="EventItem.Question1">
          問題1 {{ EventItem.Question1}} <br>
          報到回覆:  <MyRadioWithTokenStr v-model="Question1Answer" :option-token-str="EventItem.Question1Options" token-str=","></MyRadioWithTokenStr>
        </div>
        <hr>
        <div v-if="EventItem.Question2">
          問題2 {{ EventItem.Question2}} <br>
          報到回覆:  <MyRadioWithTokenStr v-model="Question2Answer" :option-token-str="EventItem.Question2Options" token-str=","></MyRadioWithTokenStr>
        </div>
        <hr>
        <div v-if="EventItem.Question3">
          問題3 {{EventItem.Question3}} <br>
          報到回覆:  <MyRadioWithTokenStr v-model="Question3Answer" :option-token-str="EventItem.Question3Options" token-str=","></MyRadioWithTokenStr>
        </div>

        <a role="button" class="btn btn-primary" @click="btnCheckIn">確認報到</a>
      </div>
      <div v-else>
<!--        {{EventItemSystemId}}-->
        報到場次:{{Event.Name}} <br>
        <div v-if="Event.Type===CheckIn_EventItemType_Open">
          開放型(不需預先報名)
        </div>
        <div v-else-if="Event.Type===CheckIn_EventItemType_NeedReg">
          需先報名
        </div>




        請掃描社員名牌
      </div>

      <MyQRCodeScanWithValidate style="max-width: 500px;max-height: 600px;" v-model="qrCode" v-on:scaned="scanedQRCode"></MyQRCodeScanWithValidate>

    </div>
  </div>
</template>

<script>
// import MyQRCodeScan from "@/views/taylorAdmin/component/MyQRCodeScan";
import MyQRCodeScanWithValidate from "@/views/taylorAdmin/component/MyQRCodeScanWithValidate";
import util from "@/util/util";
import apiCheckIn from "@/views/checkInAdmin/js/apiCheckIn";
import apiAdmin from "@/views/taylorAdmin/js/apiAdmin";
import MyRadioWithTokenStr from "@/views/taylorAdmin/component/MyRadioWithTokenStr";
import {CheckIn_EventItemType_Open,CheckIn_EventItemType_NeedReg} from "@/views/checkInAdmin/js/checkInDeclare";
/**

 **/


export default {
  components: {MyRadioWithTokenStr, MyQRCodeScanWithValidate},
  //name: "index",
  // props: [""],
  data: function () {
    return {
      CheckIn_EventItemType_Open:CheckIn_EventItemType_Open,
      CheckIn_EventItemType_NeedReg:CheckIn_EventItemType_NeedReg,
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      memberUUID:"",
      qrCode:"",
      Event:{},
      EventItem:{},

      Question1Answer:"",
      Question2Answer:"",
      Question3Answer:"",
      CanCheckIn:true,
    };
  },
  methods: {
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    scanedQRCode(){
      let memberUUIDOrg=this.qrCode;

      this.memberUUID=memberUUIDOrg.replace("https://qr.rid3482.org/m?id=","");

      let that=this;

      let loader=util.ShowLoading(this);

      apiCheckIn.api_Client_MemberInfo_uuid(this.memberUUID).then((data)=>{
        that.formData=apiAdmin.initReturnObjectWithTemplate(data.data.data,that.formData);
        // that.EventSystemId=that.formData.EventSystemId;

        apiCheckIn.api_Client_CheckMemberCanCheckIn(that.Event.SystemId,that.EventItem.SystemId, that.memberUUID).then((dataCheckIn)=>{
          let msg=dataCheckIn.data.data;

          that.CanCheckIn=msg;

          if (!that.CanCheckIn){
            alert("未報名此場次")
          }
          util.HideLoading(loader);
        });


      });
    },
    btnCheckIn(){
      // let that=this;

      let loader=util.ShowLoading(this);

      apiCheckIn.api_Client_ScanEventItem(this.memberUUID,this.Event.SystemId,this.EventItem.SystemId,"admin",this.Question1Answer,this.Question2Answer,this.Question3Answer).then((data)=>{
        let msg=data.data.data;
        // that.EventSystemId=that.formData.EventSystemId;

        if (msg){
          alert(msg)
        }else{
          alert('報到成功')
        }

        util.HideLoading(loader);
      });
    }
  },
  mounted() {
    //this.loadData()
    let event=this.$route.query.Event;
    let eventItem=this.$route.query.EventItem;

    this.Event=event;
    this.EventItem=eventItem;
  },
}
</script>

<style scoped>

</style>
